export default __webpack_public_path__ + "static/animation-1086a5568905dd1a98ec0068a244dc5e.mp4";